<div class="container-fluid" *ngIf="oaShow; else showSpinner">
  <form #oaForm="ngForm">
    <div class="row top10 no-gutters">
      <div class="col-xs-12 col-lg-4 vcenter">
        <h4>
          {{oaProjectName}} - {{ oa?.oanumber || 'New'}}
        </h4>

      </div>
      <div class="col-xs-12 col-lg-8 vcenter-right">
        <div class="btn-group" role="group" aria-label="...">
          <!--<button type="button"
                class="btn btn-info btn-sm"
                *ngIf="equipment.equipmentId != 0"
                [disabled]="!eqForm.valid && eqForm.touched"
                (click)="printEquip()">
          <i class="fas fa-print"></i>&nbsp;Print
        </button>-->
          <button type="button"
                  [ngClass]="{'btn':true,'btn-default':oaForm.form.pristine,'btn-warning':oaForm.form.dirty,'btn-sm':true}"
                  [disabled]="(!oaForm.valid
                    || !permissions.canUpdate(permissions.ComponentID.OverAndAboveProject)
                    || saveClicked)"
                  (click)="saveOA()">
            <i class="fas fa-save"></i>&nbsp;Save
          </button>
        </div>
      </div>
    </div>
    <hr style="margin-top:2px;margin-bottom:2px" />
    <mat-tab-group>
      <mat-tab label="Details">
        <ng-template matTabContent>
            <br/>
          <aims-form cols="4">
            <aims-fc spanCols="3" [showDescendants]="false">
              <aims-form cols="3">
                <aims-fc [editable]="isNew" [labelColSize]="12" [controlColSize]="12">
                    <mat-form-field>
                        <input #aimsControl="ngModel" matInput class="fullWidth" type="text" name="O&A Number" [(ngModel)]="oa.oanumber" required />
                    </mat-form-field>
                </aims-fc>
                <aims-fc [labelColSize]="12" [controlColSize]="12">
                    <mat-form-field>
                        <input #aimsControl="ngModel" matInput class="fullWidth" type="text" name="Project ID" [(ngModel)]="oa.projId" />
                    </mat-form-field>
                </aims-fc>
                <aims-fc spanCols="3" [labelColSize]="12" [controlColSize]="12">
                    <mat-form-field>
                        <input #aimsControl="ngModel" matInput class="fullWidth" type="text" name="Description" [(ngModel)]="oa.projectDescription" required />
                    </mat-form-field>
                </aims-fc>
                <aims-fc spanCols="3" [labelColSize]="12" [controlColSize]="12">
                    <mat-form-field>
                        <input #aimsControl="ngModel" matInput class="fullWidth" type="text" name="Comments" [(ngModel)]="oa.comments" />
                    </mat-form-field>
                </aims-fc>
                <aims-fc spanCols="3" [labelColSize]="12" [controlColSize]="12">
                    <mat-form-field>
                        <input #aimsControl="ngModel" matInput class="fullWidth" type="text" name="Equipment Needs" [(ngModel)]="oa.equipNeeds" />
                    </mat-form-field>
                </aims-fc>
                <aims-fc spanCols="3" [labelColSize]="12" [controlColSize]="12">
                    <mat-form-field>
                        <input #aimsControl="ngModel" matInput class="fullWidth" type="text" name="Crew Needs" [(ngModel)]="oa.crewNeeds" />
                    </mat-form-field>
                </aims-fc>
                <aims-fc spanCols="3" [labelColSize]="12" [controlColSize]="12">
                    <mat-form-field>
                        <input #aimsControl="ngModel" matInput class="fullWidth" type="text" name="Subcontractors" [(ngModel)]="oa.subcontractors" />
                    </mat-form-field>
                </aims-fc>
                <aims-fc>
                    <mat-form-field>
                        <input #aimsControl="ngModel" matInput class="fullWidth" type="text" name="Sites" [(ngModel)]="oa.sites" />
                    </mat-form-field>
                </aims-fc>
                <aims-fc>
                    <mat-form-field>
                        <input #aimsControl="ngModel" matInput class="fullWidth" type="text" name="Engineer POC" [(ngModel)]="oa.engineerPoc" />
                    </mat-form-field>
                </aims-fc>
                <aims-fc>
                    <mat-form-field>
                        <input #aimsControl="ngModel" matInput class="fullWidth" type="text" name="Site POC" [(ngModel)]="oa.sitePoc" />
                    </mat-form-field>
                </aims-fc>
                <aims-fc>
                    <mat-form-field>
                        <input #aimsControl="ngModel" matInput class="fullWidth" type="text" name="Drafting Needs" [(ngModel)]="oa.drafting" />
                    </mat-form-field>
                </aims-fc>
                <aims-fc>
                    <mat-form-field>
                        <input #aimsControl="ngModel" matInput class="fullWidth" type="text" name="Airfield Waiver" [(ngModel)]="oa.airfieldWaiver" />
                    </mat-form-field>
                </aims-fc>
                <aims-fc>
                    <mat-form-field>
                        <input #aimsControl="ngModel" matInput class="fullWidth" type="text" name="Downtime Status" [(ngModel)]="oa.downtimeStatus" />
                    </mat-form-field>
                </aims-fc>
                <aims-fc>
                    <mat-form-field>
                        <input #aimsControl="ngModel" matInput class="fullWidth" type="text" name="Approx Duration" [(ngModel)]="oa.approxWorkDuration" />
                    </mat-form-field>
                </aims-fc>
                <aims-fc>
                  <mat-form-field>
                    <input #aimsControl="ngModel" matInput class="fullWidth" type="text" name="Gov Freight" [(ngModel)]="oa.govFreight" />
                  </mat-form-field>
                </aims-fc>
                <aims-fc>
                  <input type="checkbox"
                    style="height:26px"
                    #aimsControl="ngModel"
                    name="Davis Bacon"
                    [(ngModel)]="oa.davisBacon" />
                </aims-fc>
              </aims-form>
              <aims-form>
                <aims-fc>
                    <mat-form-field>
                        <mat-label></mat-label>
                        <input name="RFP Received" matInput #aimsControl="ngModel" [matDatepicker]="picker1" [(ngModel)]="oa.rfpreceivedDate" />
                        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                        <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field>
                </aims-fc>
                <aims-fc>
                    <mat-form-field>
                        <mat-label></mat-label>
                        <input name="Prop. Submit" matInput #aimsControl="ngModel" [matDatepicker]="picker2" [(ngModel)]="oa.proposalSubmittedDate" />
                        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                        <mat-datepicker #picker2></mat-datepicker>
                    </mat-form-field>
                </aims-fc>
                <aims-fc>
                    <mat-form-field>
                        <mat-label></mat-label>
                        <input name="Sched Start" matInput #aimsControl="ngModel" [matDatepicker]="schedConstStartDate" [(ngModel)]="oa.schedConstStartDate" />
                        <mat-datepicker-toggle matSuffix [for]="schedConstStartDate"></mat-datepicker-toggle>
                        <mat-datepicker #schedConstStartDate></mat-datepicker>
                    </mat-form-field>
                </aims-fc>
                <aims-fc>
                    <mat-form-field>
                        <mat-label></mat-label>
                        <input name="Install Complete" matInput #aimsControl="ngModel" [matDatepicker]="installationCompDate" [(ngModel)]="oa.installationCompDate" />
                        <mat-datepicker-toggle matSuffix [for]="installationCompDate"></mat-datepicker-toggle>
                        <mat-datepicker #installationCompDate></mat-datepicker>
                    </mat-form-field>
                </aims-fc>
                <aims-fc>
                    <mat-form-field>
                        <mat-label></mat-label>
                        <input name="Notice To Proceed" matInput #aimsControl="ngModel" [matDatepicker]="noticeToProceedDate" [(ngModel)]="oa.noticeToProceedDate" />
                        <mat-datepicker-toggle matSuffix [for]="noticeToProceedDate"></mat-datepicker-toggle>
                        <mat-datepicker #noticeToProceedDate></mat-datepicker>
                    </mat-form-field>
                </aims-fc>
                <aims-fc>
                    <mat-form-field>
                        <mat-label></mat-label>
                        <input name="Contract Complete" matInput #aimsControl="ngModel" [matDatepicker]="contractCompletionDate" [(ngModel)]="oa.contractCompletionDate" />
                        <mat-datepicker-toggle matSuffix [for]="contractCompletionDate"></mat-datepicker-toggle>
                        <mat-datepicker #contractCompletionDate></mat-datepicker>
                    </mat-form-field>
                </aims-fc>
              </aims-form>
            </aims-fc>
            <aims-fc [showDescendants]="false">
              <aims-form cols="1" header="Job Performance">
                <aims-fc *ngIf="!isNew && oa.projId != null">
                  <table style="width:100%" *ngIf="summary; else summarySpinner">
                    <tr><td class="jpTableCell">Total Labor:</td><td>{{ summary?.labor | currency }}</td></tr>
                    <tr><td class="jpTableCell">Purchases:</td><td>{{ summary?.purchases | currency }}</td></tr>
                    <tr><td style="border-bottom:2px solid" class="jpTableCell">Travel:</td><td style="border-bottom:2px solid">{{ summary?.travel | currency }}</td></tr>
                    <tr><td class="jpTableCell">Total Costs:</td><td>{{ (summary?.labor + summary?.overHead + summary?.purchases + summary?.travel) | currency }}</td></tr>
                    <tr><td>&nbsp;</td></tr>
                    <tr><td class="jpTableCell">Difference (Profit):</td><td>{{ (oa.approvedPrice - (summary?.labor + summary?.overHead + summary?.purchases + summary?.travel)) | currency }}</td></tr>
                    <tr><td class="jpTableCell">Profit %:</td><td>{{ (oa.approvedPrice - (summary?.labor + summary?.overHead + summary?.purchases + summary?.travel))/oa.approvedPrice | percent:'1.0-2'}}</td></tr>
                  </table>
                </aims-fc>
                <aims-fc>
                    <aims-numeric [numericType]="AIMS_NUMERIC_TYPES.CURRENCY" #aimsControl="ngModel" name="Proposal Price" [(ngModel)]="oa.proposalPrice"></aims-numeric>
                </aims-fc>
                <aims-fc>
                    <aims-numeric [numericType]="AIMS_NUMERIC_TYPES.CURRENCY" #aimsControl="ngModel" name="Approved Price" [(ngModel)]="oa.approvedPrice"></aims-numeric>
                </aims-fc>
                <aims-fc>
                    <aims-numeric [numericType]="AIMS_NUMERIC_TYPES.CURRENCY" #aimsControl="ngModel" name="Neg. Profit" [(ngModel)]="oa.profit"></aims-numeric>
                </aims-fc>
                <aims-fc>
                    <aims-numeric #aimsControl="ngModel" name="Neg. Profit %" [numericType]="AIMS_NUMERIC_TYPES.PERCENT" [(ngModel)]="oa.profitPercent"></aims-numeric>
                </aims-fc>
                <aims-fc>
                    <aims-numeric #aimsControl="ngModel" name="Non-productive %" [numericType]="AIMS_NUMERIC_TYPES.PERCENT" [(ngModel)]="oa.nonProductivePercent"></aims-numeric>
                </aims-fc>
                <aims-fc>
                    <aims-numeric #aimsControl="ngModel" name="Payroll Tax %" [numericType]="AIMS_NUMERIC_TYPES.PERCENT" [(ngModel)]="oa.payrollTaxPercent"></aims-numeric>
                </aims-fc>
                <aims-fc>
                    <aims-numeric #aimsControl="ngModel" name="Overhead %" [numericType]="AIMS_NUMERIC_TYPES.PERCENT" [(ngModel)]="oa.overheadPercent"></aims-numeric>
                </aims-fc>
              </aims-form>
            </aims-fc>
          </aims-form>
        </ng-template>
      </mat-tab>
      <mat-tab label="Purchase">

        <aims-common-table
          id="purchases-table"
          [dataSource]="purchases"
          [header]="purchasesTableHeader"
          [permissions]="purchasesTablePermissions"
          [defaultTableState] = "{ sort:{ active : 'orderDate', direction: 'desc' }}"
          pageSize="10"
          [stickyHeader]="true">

            <aims-common-table-dynamic-row id="unitCost">
              <ng-template viewMode let-element >
                 {{ element.unitCost | currency: "USD":"symbol":"1.2-4" }}
              </ng-template>
            </aims-common-table-dynamic-row>

            <aims-common-table-dynamic-row id="totalCost">
              <ng-template viewMode let-element >
                 {{ element.totalCost | currency: "USD":"symbol":"1.2-4" }}
              </ng-template>
            </aims-common-table-dynamic-row>
        </aims-common-table>
      </mat-tab>

      <mat-tab label="Labor">
        <aims-common-table
          id="labor-table"
          [dataSource]="labor"
          [header]="laborTableHeader"
          [permissions]="laborTablePermissions"
          [defaultTableState] = "{ sort:{ active : 'tS_DT', direction: 'desc' }}"
          pageSize="10"
          [stickyHeader]="true">

            <aims-common-table-dynamic-row id="tS_DT">
              <ng-template viewMode let-element >
                {{ element.tS_DT | date: 'MM/dd/yyyy':'+0000' }}
              </ng-template>
            </aims-common-table-dynamic-row>

            <aims-common-table-dynamic-row id="laB_CST_AMT">
              <ng-template viewMode let-element >
                 {{ element.laB_CST_AMT | currency: "USD":"symbol":"1.2-4" }}
              </ng-template>
            </aims-common-table-dynamic-row>

            <aims-common-table-dynamic-row id="fringe">
              <ng-template viewMode let-element >
                 {{ element.fringe | currency: "USD":"symbol":"1.2-4" }}
              </ng-template>
            </aims-common-table-dynamic-row>

            <aims-common-table-dynamic-row id="nonProd">
              <ng-template viewMode let-element >
                 {{ element.nonProd | currency: "USD":"symbol":"1.2-4" }}
              </ng-template>
            </aims-common-table-dynamic-row>

            <aims-common-table-dynamic-row id="payrollTax">
              <ng-template viewMode let-element >
                 {{ element.payrollTax | currency: "USD":"symbol":"1.2-4" }}
              </ng-template>
            </aims-common-table-dynamic-row>

            <aims-common-table-dynamic-row id="overhead">
              <ng-template viewMode let-element >
                 {{ element.overhead | currency: "USD":"symbol":"1.2-4" }}
              </ng-template>
            </aims-common-table-dynamic-row>

            <aims-common-table-dynamic-row id="labor">
              <ng-template viewMode let-element >
                 {{ element.labor | currency: "USD":"symbol":"1.2-4" }}
              </ng-template>
            </aims-common-table-dynamic-row>
        </aims-common-table>
      </mat-tab>

      <mat-tab label="Travel">
        <aims-common-table
          id="travel-table"
          [dataSource]="travel"
          [header]="travelTableHeader"
          [permissions]="travelTablePermissions"
          [defaultTableState] = "{ sort:{ active : 'noticeToProceedDate', direction: 'desc' }}"
          pageSize="10"
          [footer]="true"
          [stickyHeader]="true">

            <aims-common-table-dynamic-row id="amt">
              <ng-template viewMode let-element >
                {{ element.amt | currency: "USD":"symbol":"1.2-4" }}
              </ng-template>

              <ng-template aimsFooterTemplate let-element>
                {{ getTotalTravelCost() | currency: "USD":"symbol":"1.2-4" }}
              </ng-template>
            </aims-common-table-dynamic-row>
        </aims-common-table>
      </mat-tab>

      <mat-tab label="Work Orders">
        <app-standard-view-workorders [workOrders]="workOrders" [selectedGrid]="'basic'"></app-standard-view-workorders>
      </mat-tab>
    </mat-tab-group>
  </form>
</div>

<ng-template #showSpinner>
  <aims-spinner showSpinner="true" spinnerText="Loading..."></aims-spinner>
</ng-template>

<ng-template #summarySpinner>
  <div style="width:100%; text-align:center">
    <img src="{{spinnerSrc}}/spinner.gif" />
  </div>
</ng-template>
